const getUserAgent = () => (typeof navigator !== 'undefined' ? navigator.userAgent : '');

const isIOS = () => {
    if (typeof navigator === 'undefined') return false;
    const ua = getUserAgent();
    const isIPhone = /iPhone/.test(ua);
    const isIPad = /iPad/.test(ua);
    const isIPod = /iPod/.test(ua);
    const isIPadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return isIPhone || isIPad || isIPod || isIPadOs;
};

const getDevicePixelRatio = () => {
    if (typeof window === 'undefined') return 1;
    return window.devicePixelRatio || 1;
};

const IOS_MAX_PIXEL_RATIO = 1.5;

const getEffectivePixelRatio = (maxPixelRatio?: number) => {
    const dpr = getDevicePixelRatio();
    const cap = maxPixelRatio ?? (isIOS() ? IOS_MAX_PIXEL_RATIO : dpr);
    return Math.min(dpr, cap);
};

export { isIOS, getDevicePixelRatio, getEffectivePixelRatio, IOS_MAX_PIXEL_RATIO };
